import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Query } from 'react-apollo';
import { PORTAL_ESTABLISHMENTS_QUERY } from 'src/components/Pages/Commissions/graphql';
import { Field } from 'react-final-form';


function EstablishmentsSelect({ operatorId }) {
    const variables = {
        operatorId
    };
    return (
        <Field
            name="establishmentId"
            component="select"
            className="form-control form-control-alternative"
        >
            <option value="">Todos</option>
            <option key="Nenhum" value="Nenhum">Nenhum</option>
            <Query query={PORTAL_ESTABLISHMENTS_QUERY} variables={variables}>
                {({ loading, error, data }) => {
                    if (loading || error) return <Fragment />;
                    const { portalEstablishments } = data;
                    const options = portalEstablishments.map(establishment => (
                        <option
                            key={establishment.id}
                            value={establishment.id}
                        >
                        {establishment.title} - {(establishment.address) ? establishment.address.state : ''}
                        </option>
                    ));
                    return options;
                }}
            </Query>
        </Field>
    );
}

const mapStateToProps = (state) => ({
    operatorId: state.session.operatorId
});

export default connect(mapStateToProps)(EstablishmentsSelect);



// WEBPACK FOOTER //
// ./src/components/Pages/Commissions/Filters/EstablishmentsSelect.js